import React from 'react'

import Header from "../Header/Header";
import NavbarMarquee from "../NavBarMarquee/NavbarMarquee"
import Navbar from '../NavBar/Navbar';
import MesoOne from "../Meso-one/MesoOne"
import HomeSix from "../Home-six/HomeSix"
import Hometwo from "../Home-two/Hometwo"
import HomeThree from "../Home-three/HomeThree"
import HomeFour from "../Home-four/HomeFour"
import Footer from "../Footer/Footer"
import HomeFive from "../Home-five/HomeFive"
import HomeSeven from '../Home-Seven/HomeSeven';
import CLAIMFORMPage2 from "../../Components/Home-Eight/HomeEight"
import { useEffect } from 'react';
function MesoMain() {
    useEffect(() => {
        window.scrollTo(0, 0);  
    }, []);
    return (
        <div className='w-auto h-full overflow-hidden'>
            {/* <Header /> */}
            <NavbarMarquee />
            {/* <Navbar/> */}
             {/* <Marquee/> */}
            <MesoOne />
            <Hometwo />
            <HomeThree />
            <HomeFour />
            <HomeFive />
            <HomeSix />
            <HomeSeven />
            <CLAIMFORMPage2 />
            <Footer />
        </div>
    )
}

export default MesoMain
